import React, { forwardRef } from 'react';

import { FocusHandler, KeyPressDetails } from '@noriginmedia/norigin-spatial-navigation';
import Button from '@smart-tv/components/button/button';

import styles from './button-group.module.scss';

export interface Buttons {
  label: string;
  selected?: boolean;
  onEnterPress?: (props?: object, details?: KeyPressDetails) => void;
  dataTestId?: string;
}

export interface Props {
  buttons?: Buttons[];
  onNavFocus?: FocusHandler;
  focusedIndex?: number;
  dataTestId: string;
  ariaLabelledBy?: string;
}

const ButtonGroup = forwardRef<HTMLDivElement, Props>(function ButtonGroup(props, ref) {
  const { buttons, onNavFocus, focusedIndex, dataTestId, ariaLabelledBy } = props;

  return (
    <div
      data-testid={dataTestId}
      ref={ref}
      className={styles['button-group']}
      role="group"
      aria-labelledby={ariaLabelledBy}
    >
      {buttons?.map(({ label, onEnterPress, selected, dataTestId }, index) => (
        <Button
          key={index}
          onClick={() => onEnterPress?.()}
          selected={selected}
          aria-pressed={selected}
          variant="header"
          data-testid={dataTestId?.toLowerCase()}
          onNavFocus={onNavFocus}
          expandOnFocus={true}
          isFocused={index === focusedIndex}
        >
          {label}
        </Button>
      ))}
    </div>
  );
});

export default React.memo(ButtonGroup);
